<template>
    <div class="card mt-3" style="margin-bottom:10px">


        <div class="row">
            <!-- Imagen de perfil -->
            <div class="col-md-3 d-flex justify-content-center">
                <div class="perfil-lateral">
                    <div class="profile-img">
                        <span class="profile-initials">{{ infoPaciente.iniciales }}</span>
                    </div>

                    <button v-if="tieneHistorial" @click="revisarHistorial" type="button" class="btn-historial">
                        <i class="fas fa-file-medical"></i>
                        <span>Revisar historial</span>
                    </button>

                </div>


            </div>
            

            <!-- Información del paciente -->
            <div class="col-md-9 mb-2">
                <div class="card-container info-paciente">
                    <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                        <span>INFORMACIÓN DEL PACIENTE</span>
                        <i class="bi bi-pencil-square"></i>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <p><strong>Nombres y apellidos: </strong>{{ infoPaciente.displayName }} {{
                                    infoPaciente.lastName }}</p>
                                <p><strong>Edad: </strong>{{ infoPaciente.edad }}</p>
                                <p><strong>Tipo de Identificación: </strong> {{ infoPaciente.tipoCiudadano }}</p>
                                <p><strong>Identificación: </strong> {{ infoPaciente.identificacion }}</p>
                                <p><strong>Sexo: </strong> {{ infoPaciente.sexo }}</p>
                            </div>
                            <div class="col-md-6">
                                <p><strong>Estado civil: </strong> {{ infoPaciente.estado_civil }}</p>
                                <p><strong>Fecha nacimiento:</strong> {{ infoPaciente.fech_nacimiento }}</p>
                                <p><strong>E-mail:</strong> {{ infoPaciente.email }}</p>
                                <p><strong>Celular:</strong> {{ infoPaciente.celular }}</p>
                                <p><strong>Ocupación:</strong> {{ infoPaciente.ocupacion }}</p>
                                <p><strong>Fecha de registro:</strong> {{ infoPaciente.fecha_registro }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>








        <div class="row">
            <swiper-pacientes />
        </div>

    </div>

    <div v-if="showHistorial" class="historial-modal" @click.self="cerrarHistorial">
        <div class="historial-dialog" role="dialog" aria-modal="true" aria-labelledby="titulo-historial">
            <div class="historial-header">
                <h6 id="titulo-historial">Historial de atenciones</h6>
                <button type="button" class="btn-cerrar" @click="cerrarHistorial" aria-label="Cerrar">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="historial-body">
                <perfil-historial-atenciones />
            </div>
        </div>
    </div>

</template>


<script>
/* eslint-disable */
import SwiperPacientes from './SwiperPacientes.vue';
import PerfilHistorialAtenciones from '../HistorialAtenciones/PerfilHistorialAtenciones.vue';

export default {
    name: "Perfil-Dashboard-Atencion",
    components: {
        SwiperPacientes,
        PerfilHistorialAtenciones
    },

    data() {
        return {
            loading: true,
            showHistorial: false,
            tieneHistorial: false,
            isMobile: this.$isMobile,
            cod_paciente: this.$route.query.cod_paciente,
            idPaciente: this.$route.query.idPaciente,
            infoPaciente: {
                iniciales: '',
                displayName: '',
                lastName: '',
                iniciales: '',
                edad: '',
                tipoCiudadano: '',
                identificacion: '',
                sexo: '',
                estado_civil: '',
                fech_nacimiento: '',
                email: '',
                celular: '',
                ocupacion: '',
                fecha_registro: ''

            },

        };
    },
    computed: {},
    
    watch: {
    '$route.query': {
        immediate: true, // Ejecutar el watcher inmediatamente al montar el componente
        handler(newQuery, oldQuery) {
            if (newQuery.cod_paciente !== oldQuery?.cod_paciente || newQuery.idPaciente !== oldQuery?.idPaciente) {
                this.cod_paciente = newQuery.cod_paciente;
                this.idPaciente = newQuery.idPaciente;
                this.tieneHistorial = false;
                this.showHistorial = false;
                this.cargaDatosPaciente(); // Volver a cargar los datos
            }
        }
    }
},

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.cargaDatosPaciente()


    },
    methods: {
        revisarHistorial() {
            this.showHistorial = true;
        },

        cerrarHistorial() {
            this.showHistorial = false;
        },

        verificarHistorial() {
            this.tieneHistorial = false;

            if (!this.idPaciente) return;

            this.$https.post('/historial/getLoadHistorialPaciente', { idPaciente: this.idPaciente }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (response.data.code !== 200 || !response.data.consul?.length) {
                    this.tieneHistorial = false;
                    return;
                }

                const paciente = response.data.consul[0];
                const fechasConsultas = (paciente.consultas || [])
                    .filter(consulta => consulta.tratamiento && consulta.tratamiento.length > 0);

                this.tieneHistorial = fechasConsultas.length > 0;
            }).catch(() => {
                this.tieneHistorial = false;
            });
        },

        cargaDatosPaciente() {
            this.$https.post('/consulta/getLoadPacienteId', { codigoId: this.cod_paciente }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {

                    let resp = response.data.datos[0]

                    //this.infoPaciente
                    this.infoPaciente.displayName = resp.nombres
                    this.infoPaciente.lastName = resp.apellidos
                    this.infoPaciente.edad = this.calcularEdad(resp.nacimiento)
                    this.infoPaciente.tipoCiudadano = resp.tipo_identificacion
                    this.infoPaciente.identificacion = resp.cedula
                    this.infoPaciente.iniciales = resp.nombres.charAt(0) + resp.apellidos.charAt(0)
                    this.infoPaciente.sexo = resp.sexo
                    this.infoPaciente.estado_civil = resp.estado_civil
                    this.infoPaciente.fech_nacimiento = resp.nacimiento
                    this.infoPaciente.email = resp.correo
                    this.infoPaciente.celular = resp.celular
                    this.infoPaciente.ocupacion = resp.ocupacion
                    this.infoPaciente.fecha_registro = resp.created_at

                    this.verificarHistorial();
                }


            }).catch(error => {



                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`, // Usa HTML para darle formato
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })
        }
    }

}



</script>


<style scoped>
.perfil-lateral {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
}

.profile-img {
    width: 160px;
    height: 160px;
    background-color: #cce5ff;
    border-radius: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: bold;
    color: #0078be !important;
    border: 5px solid white;
    position: relative;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}

.perfil-lateral .btn-historial {
    margin-top: auto;
}

.profile-initials {
    text-transform: uppercase;
}

.card-header {
    font-weight: bold;
    background: #0078be !important;
}

.info-paciente .card-header {
    padding: 8px 14px;
    font-size: 13px;
}

.info-paciente .card-body {
    padding: 10px 14px 8px;
}

.info-paciente p {
    margin: 0 0 6px;
    line-height: 1.35;
    font-size: 13px;
}

.card-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
    /* transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out; */
}

.btn-historial {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    border-radius: 999px;
    padding: 10px 16px;
    background: #f44283;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.2px;
    box-shadow: 0 0 0 0 rgba(244, 66, 131, 0.55);
    animation: llamarAtencion 1.6s ease-out infinite;
}

.btn-historial:hover {
    background: #d12d6c;
    animation: none;
    transform: translateY(-1px);
}

@keyframes llamarAtencion {
    0% {
        box-shadow: 0 0 0 0 rgba(244, 66, 131, 0.55);
    }
    70% {
        box-shadow: 0 0 0 12px rgba(244, 66, 131, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(244, 66, 131, 0);
    }
}

.historial-modal {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(15, 23, 42, 0.45);
}

.historial-dialog {
    width: min(1100px, 100%);
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.22);
}

.historial-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    background: #0078be;
}

.historial-header h6 {
    margin: 0;
    color: #fff;
    font-weight: 700;
}

.btn-cerrar {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
}

.historial-body {
    overflow: auto;
    padding: 0 8px 12px;
}
</style>
